export default __webpack_public_path__ + "static/media/button_round.b2990746.png";